import { Component, Input } from '@angular/core';
import { IconDef } from '../icons/icon';
import { IconComponent } from '../icons/icon-reusable';

@Component({
  selector: 'app-icon-title-reusable',
  standalone: true,
  imports: [IconComponent],
  template: `
    <div class="flex items-center gap-2 mb-5">
      <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl pt-1 bg-indigo-100">
        <app-icon-reusable [icon]="icon" [size]="iconSize" [color]="iconColor"></app-icon-reusable>
      </div>
      <div>
        <h3 [class]="titleClass">{{ title }}</h3>
      </div>
    </div>
  `,
})
export class IconTitleReusableComponent {
  @Input() title = '';
  @Input() icon!: IconDef;
  @Input() iconSize = 18;
  @Input() iconColor = '#4F46E5';
  @Input() titleClass = 'text-fs16 font-bold text-gray-900';
}